define((require) => {
    "use strict";

    var TextWidgetModel = require("shared/ui/experience/widgets/textEnhancedWidget/TextWidgetModel");

    /**
     * @class {TextWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return TextWidgetModel.mixin("TextWidgetModelEditorMixin", {
        /**
         * Returns the text value without html attributes
         *
         * @return {string} The stripped text value
         */
        _stripHtmlText() {
            const tmp = document.createElement("DIV");
            tmp.innerHTML = this.get("text");
            return tmp.textContent || tmp.innerText || "";
        },

        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            if (this.isValid() && this.hasText()) {
                // rawText is a transient property that will update on text changes to speed up label retrieval while editing.
                if (this.has("rawText")) {
                    return this.get("rawText");
                }
                let rawText = this._stripHtmlText();
                this.set("rawText", rawText);
                return rawText;
            }
            return null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textEnhancedWidget/TextWidgetModelEditorMixin.js